<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16">
    <path d="M9.674 1.312v3.344H4.658V1.312m5.015 8.36a1.672 1.672 0 01-1.672 1.672A1.672 1.672 0 016.33 9.672 1.672 1.672 0 018 7.999a1.672 1.672 0 011.672 1.673zm-6.687-8.36h8.356l3.345 3.344v8.36a1.672 1.672 0 01-1.673 1.672H2.986a1.672 1.672 0 01-1.673-1.672V2.987a1.672 1.672 0 011.673-1.675" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"/>
  </svg>
</template>
